import { Tag, Form, Select, Button, Spin, Input, Card, message, Popconfirm, Tooltip, Empty, Table } from 'antd';
import { EOrgaoCodigo, EOrgaoDescricao } from '../../../../components/enums/orgao.enum';
import Api from '../../../../services/api';
import { useEffect, useState } from 'react';
import { useParams, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as PermissaoAction from '../../../../redux/actions/permissao';
import api from '../../../../services/api';
import * as ModalStatusAction from '../../../../redux/actions/modalStatus'

interface props {
    dados: any;
    permissao?: any
    setRealizarAtendimento?: any,
}

interface Orgao {
    orgaoID: any,
    nome: String,
    sigla: String,
    ativo: Boolean
}
interface Vinculo {
    vinculoOrgaoServicoID: any,
    orgaoID: Number,
    servicoID: Number,
    ativo: Boolean,
    orgao: {
        orgaoID: Number,
        nome: String,
        sigla: String,
        ativo: Boolean
    },
    servico: {
        servicoID: any,
        descricao: String,
        ativo: Boolean
    }
}
const ServicosOfertados: React.FC<props> = (props) => {
    const { TextArea } = Input;
    const history = useHistory()
    const [outro, setOutro] = useState<boolean>(true);
    const [form] = Form.useForm();
    const { id } = useParams<Record<string, string | undefined>>();
    const { agendamentoID } = useParams<Record<string, string | undefined>>();
    const [orgaos, setOrgaos] = useState<Array<Orgao>>([]);
    const [vinculos, setVinculos] = useState<Vinculo[]>();
    const [servicosOfertados, setservicosOfertados] = useState<
        {
            servicoOfertadoID: number,
            dadosCadastraisID: number,
            orgaoID: number,
            nomeOrgao: String | undefined,
            nomeServico: String | undefined,
            descricao: String | undefined
        }[]>([]);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [indexTag, setIndexTag] = useState<number>();
    const [permissaoUserEditar, setPermissaoUserEditar] = useState<boolean>(false);

    let location = useLocation();
    var currentLocation = location.pathname

    let paths = currentLocation.split('/');

    useEffect(() => {
        getOrgaos();
        mapAgendamentos(props.dados?.servicosOfertados);

        if (paths[4] == "agendamento" && props.permissao[0].permissaoAcesso?.editar == false) {
            setPermissaoUserEditar(true);
        } else {
            setPermissaoUserEditar(props.permissao[0].permissaoAcesso?.editar);
        }
    }, [props.dados])

    async function getOrgaos() {
        await api.post(`Orgao/getcomfiltros`, {
            orgaoID: 0,
            Nome: null,
            Sigla: null,
            Ativo: true,
        })
            .then(response => {
                setOrgaos(response.data);
            });
    }
    const mapAgendamentos = (servicosOfertados: any) => {
        
        if (servicosOfertados !== undefined && servicosOfertados !== null) {            
            servicosOfertados?.map((s: any) => {

                setservicosOfertados(state => [...state,
                {
                    dadosCadastraisID: s.dadosCadastraisID,
                    servicoOfertadoID: s.servicoOfertadoID,
                    orgaoID: s?.vinculoOrgaoServico?.orgaoID,
                    nomeOrgao: s?.vinculoOrgaoServico?.orgao.nome,
                    nomeServico: s?.vinculoOrgaoServico?.servico.descricao,
                    descricao: s?.descricao
                }])
            })
        }

    }
    async function getVinculoOrgaoServico(orgaoId: any) {
        await api.post("VinculoOrgaoServico/getcomfiltros",
            { orgaoID: orgaoId, ativo: true })
            .then(response => setVinculos(response.data));

    }
    const submit = async (value: any) => {
        if (value.orgao !== 0)
            form.setFieldsValue({ outro: null });
        setLoading(true);
        let nomeOrgao = vinculos?.find(v => v.orgaoID == value.orgao && v.vinculoOrgaoServicoID == value.servico);

        await Api.post("ServicoOfertado", {
            DadosCadastraisID: id ? parseInt(id) : 0,
            AgendamentoID: agendamentoID ? parseInt(agendamentoID) : 0,
            vinculoOrgaoServicoID: value.servico,
            orgao: value.orgao,
            descricao: value.descricao

        }).then((response) => {
            var array = servicosOfertados.slice();
            array.unshift({
                servicoOfertadoID: response.data?.servicoOfertado.servicoOfertadoID,
                dadosCadastraisID: id ? parseInt(id) : 0,
                orgaoID: value.orgao,
                nomeOrgao: nomeOrgao?.orgao.nome,
                nomeServico: nomeOrgao?.servico.descricao,
                descricao: value.descricao
            })
            setservicosOfertados(array);
            message.success('Salvo com sucesso')
            form.resetFields();
        })
            .catch((err) => {
                message.error(err?.response?.data?.message ? err?.response?.data?.message : 'Falha na requisição')

            }).finally(() => {
                setVinculos([])
                setLoading(false)
            })
    }

    const deletarServicoOfertado = async (servicoOfertadoID: number) => {
        setVisible(false);

        if (permissaoUserEditar === false) {
            message.warn("Usuário não possui permissão de exclusão")
            return;
        }
        await Api
            .delete(`ServicoOfertado?id=${servicoOfertadoID}`)
            .then(res => {
                setservicosOfertados(servicosOfertados.filter((item) => { return item.servicoOfertadoID != servicoOfertadoID })
                )
                message.success("Removido com sucesso");
            })
            .catch(err => {
                message.error("Falha na remoção");
            });
    }

    const preventDefault = (e: any, index: number) => {
        e.preventDefault();
        setVisible(true);
        setIndexTag(index);

    }
    const onCancel = () => {
        setVisible(false);
    }

    const finalizarAtendimento = async () => {
        var usuarioLogado = JSON.parse(sessionStorage.getItem('usuarioLogado') || '{}')
        await Api.put(`Agendamento/FinalizarAtendimento?id=${agendamentoID}&usuarioID=${usuarioLogado.usuarioID}`).then((response) => {
            if (response.data?.valido === false)
                message.error(response.data?.error)
            else
                message.success('Agendamento/Atendimento finalizado com sucesso')
            setLoading(false);
            props.setRealizarAtendimento(false)
            history.push("/home");
        })
            .catch((err) => {
                props.setRealizarAtendimento(false)
                message.error('Falha na requisição')
                setLoading(false);
            });
    }

    const columns = [
        {
            title: 'Orgão',
            dataIndex: 'nomeOrgao',
        },
        {
            title: 'Serviço',
            dataIndex: 'nomeServico',
        },
        {
            title: 'Ações', dataIndex: '', key: 'x', width: 120,

            render: (text: any, record: any) => (
                <>
                    <Popconfirm key={record.servicoOfertadoID} placement="top" title="Você tem certeza que deseja excluir esse item?" onConfirm={() => { deletarServicoOfertado(record.servicoOfertadoID) }} okText="Sim" cancelText="Não">
                        <Button htmlType="button" type="primary" key={record.servicoOfertadoID} danger>Excluir</Button>
                    </Popconfirm>
                </>
            ),
        },
    ];

    return (
        <>
            <div className="container">
                <Spin spinning={loading}>

                    <Form
                        form={form}
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        size="middle"
                        onFinish={submit}
                    >
                        <div className="row custom-row encaminhar">
                            <div className="col-md-5">
                                <Form.Item rules={[
                                    {
                                        required: true,
                                        message: 'Informe campo!',
                                    }
                                ]} name="orgao" label="Encaminhar para " labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                    <Select
                                        onSelect={(e: any) => { getVinculoOrgaoServico(e); }}
                                        placeholder="Selecione um órgão"
                                        disabled={permissaoUserEditar === false}
                                    >
                                        {orgaos.map((option, index) => {
                                            return option?.ativo ?
                                                <Select.Option key={index} value={option.orgaoID}>
                                                    {option.nome} - ({option.sigla})
                                                </Select.Option>
                                                : null;
                                        })}
                                    </Select>

                                </Form.Item>
                            </div>
                            <div className="col-md-5">
                                <Form.Item rules={[
                                    {
                                        required: true,
                                        message: 'Informe campo!',
                                    }
                                ]} name="servico" label="Serviço do Encaminhamento" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                    <Select
                                        notFoundContent={<Empty description="Selecione um órgao com serviço ativo!" />}
                                        onChange={(e) => { e === 0 ? setOutro(false) : setOutro(true) }}
                                        placeholder="Selecione um serviço!"
                                        disabled={permissaoUserEditar === false}
                                    >
                                        {vinculos?.map((option, index) => {
                                            return option.servico?.ativo ? <Select.Option key={index} value={option.vinculoOrgaoServicoID}>
                                                {option.servico.descricao}
                                            </Select.Option> : null;
                                        })
                                        }
                                    </Select>

                                </Form.Item>
                            </div>
                            <div className="col-md-2">
                                <Form.Item label="⠀⠀⠀⠀⠀⠀⠀⠀⠀" labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                    {permissaoUserEditar === true ?
                                        <Button htmlType="submit" type="primary">Adicionar</Button>
                                        :
                                        <Button disabled type="primary">Adicionar</Button>
                                    }
                                </Form.Item>
                            </div>
                            {/* <div className="col-md-4">
                                <div className="grid fd-column">
                                    <div className="col-md-12">
                                        <Form.Item name="descricao" label="Descrição " labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}>
                                            <TextArea maxLength={450} showCount rows={4}></TextArea>
                                        </Form.Item>
                                    </div>
                                    
                                </div>
                            </div> */}
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Encaminhado para:</label>
                                <Table loading={loading} columns={columns} dataSource={servicosOfertados} rowKey={"servicoOfertadoID"} bordered={true}></Table>
                                {/* <Card bordered={true}>
                                    {servicosOfertados ? servicosOfertados.map((option, index) => {
                                        return <Popconfirm key={index} visible={visible && indexTag == index}
                                            onCancel={onCancel}
                                            onConfirm={() => { deletarServicoOfertado(option.servicoOfertadoID) }} placement="top" title="Você tem certeza que deseja excluir o encaminhamento?" okText="Sim" cancelText="Não">
                                            <Tooltip title={'Serviço: ' + option.nomeServico}>
                                                <Tag key={index} closable onClose={(e: any) => { preventDefault(e, index) }} >
                                                    {option.orgaoID !== 0 ? option.nomeOrgao : null}
                                                </Tag>
                                            </Tooltip>
                                        </Popconfirm>
                                    }) : null}

                                </Card> */}
                            </div>

                        </div>
                        <br />
                        <div className="row">
                            <div className="col-md-4">
                                <Form.Item className="align-items-end">
                                    {agendamentoID && permissaoUserEditar === true ? <Popconfirm placement="top" title="Você tem certeza que quer finalizar o atendimento?" onConfirm={finalizarAtendimento} okText="Sim" cancelText="Não">
                                        <Button type="primary">Finalizar Atendimento</Button>
                                    </Popconfirm> : null}
                                </Form.Item>
                            </div>
                        </div>

                    </Form>
                </Spin>
            </div>



        </>
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}

export default connect(mapStateToProps, mapDispatcToProps)(ServicosOfertados);
